'use client';

import {useEffect, useState} from 'react';
import DrawTwoToneIcon from '@mui/icons-material/DrawTwoTone';
import {Link} from "react-router-dom";
import {AccountBoxTwoTone, AppsTwoTone, HelpTwoTone, ShareTwoTone} from "@mui/icons-material";
import {Button} from "reactstrap";
import Story from "./thumbs/story";

const ProfileCard = ({ user, onEdit })=>{



 return (

   <>




  <div className="card"> {user.name}</div>
  <button onClick={() => onEdit(true)}>edit</button>
</>
)

}
const EditProfileForm = ({user, onSave, onCancel}) => {
  const styles = {};
  const [tryx, setTryx] = useState(null);
  const [name, setName] = useState(user.name);

  const [email, setEmail] = useState(user.email);

  const [bio, setBio] = useState(user.bio);

  const [form, setForm] = useState({

    name: user.name,

    email: user.email,

    bio: user.bio,

  });


  const handleNameChange = (e) => {

    const newVal = e.target.value;

    setName(newVal);

    setForm({...form, name: newVal});

  };


  const handleEmailChange = (e) => {

    const newVal = e.target.value;

    setEmail(newVal);

    setForm({...form, email: newVal});

  };


  const handleBioChange = (e) => {

    const newVal = e.target.value;

    setBio(newVal);

    setForm({...form, bio: newVal});

  };


  const handleSubmit = (e) => {


    onSave({...user, ...form});

  };


  return (
    <>


      { tryx && (

        <form className={styles.form} onSubmit={handleSubmit}>

          <div className={styles.field}>

            <label htmlFor="name">Name</label>

            <input

              type="text"

              id="name"

              name="name"

              value={name}

              onChange={handleNameChange}

              required

            />

          </div>

          <div className={styles.field}>

            <label htmlFor="email">Email</label>

            <input

              type="email"

              id="email"

              name="email"

              value={email}

              onChange={handleEmailChange}

              required

            />

          </div>

          <div className={styles.field}>

            <label htmlFor="bio">Bio</label>

            <textarea

              id="bio"

              name="bio"

              value={bio}

              onChange={handleBioChange}

              rows="4"

            />

          </div>

          <div className={styles.actions}>

            <button type="submit" className={styles.saveButton}>Save</button>

            <button type="button" onClick={onCancel} className={styles.cancelButton}>Cancel</button>

          </div>

        </form>


      )


      }


    </>


  )


};


const ProfilePage = () => {
  const styles = {selector: 'asdasd', container: 'asdasd', error: 'sdfsdf'};
  const [userId, setUserId] = useState(null);
  const coef = window.innerWidth/window.innerHeight;
    //localStorage.setItem('token','eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIwMTliYjE2Yi0zYmI4LTcyYjgtYTk5Yy0zZDM3NDNhMDM0OWUiLCJqdGkiOiIwZjZkNTYyN2IwNmE1YmNkZDAyMjllZTFhNWNhZDczM2EwMDZlYTk5NzY2MDUzZTBjNTI1NWQ3ZDBmODhmMDcyOTUxMmM0ZDc1MzkwOGZiNiIsImlhdCI6MTc2ODk4NTYwNS45MTc4NjUsIm5iZiI6MTc2ODk4NTYwNS45MTc4NjcsImV4cCI6MTc4NDYyNDAwNS44OTc1NDQsInN1YiI6IjM3NiIsInNjb3BlcyI6W119.NSsmXJmbCZwjBAXOVrg6WNLWGOvLbuYAE1GGcrwBWrgvRZlvyJ214-5DciezmBktM4GdcbOQsk_18V1tpNF0FcIQIYfDdoN9G3bUwr73h5nvX6RdWTFQ2c6AdRUDNK9BOVvA66o6N-LRlbUuCGZ9lC8twRDrUk7_mdjR32LFYAnIHGEKqvbKvCKtFm4bi-IPomjdTXKAvLicGfLLoQsGTCqogI4R3xBTDpez2yhKcNUW_SXGhykPF9YxZJUwQuPwMs1excwmNLZKUglmgggeIOcdteVk60wnwQCbDJFLerJvr0FkDMEJQXr6bWwyetYTYxPyomEloFLSUh7ylaAOvlFfZ-NSU3qtnCfBVOEEZmd5UDSPEuYjbY8apwF70UtY3_ZQrgePjT9RGeqKLyfpDJp95G0ohuGr7A3cj66G4T9_eY0h5LTYy16KMmbE-5Rqf-4UelwIvphHidsDHVgfyGJGuuKZw9oXSPUwQ9BLFJJkFp-PNeGbwiQO1UGCe7U2JWsAtcux40sNufur2r2Tgm5v0-9uXTmqNuxclWbHhW2b68n9cagX8628OVfIKME7NZ1V5zCCoVJmXS2HjiySaMbr-vdZCr_lv7hETwdRK-jpMVEqzrINfkVF_DdzqoU1fb7_sqxYbVvyzk9pcDBipxgHSrAh9Md5uQs8sgXTMpc');
   const token= localStorage.getItem('token');
  const [displayId, setDisplayId] = useState(1);

  const [user, setUser] = useState(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  const [isEditing, setIsEditing] = useState(false);

const userb=(e)=>{
  //e.preventDefault();
user && setIsEditing(1)
  }
  // Fetch user data whenever userId changes
    const getUser =  async ()=>{
        const h ={Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        }
       const url=process.env.REACT_APP_api+"api/users";
        //const url="http://localhost/api/users";
   try{
await fetch(url, {
                headers: h


            }).then(response => response.json()).then(
                r => {

                    if (r.data.user.email) {
                        setUser(r.data.user);

                    }

                }
            )
    }   catch (e) {

   }
    }
  useEffect(() => {




   token && getUser();

  }, [userId]);


  const handleSave = async (updatedUser) => {
    console.log(updatedUser);
    setLoading(true);

    setError(null);

    try {

      const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/user/${userId}`, {

        method: 'PUT',

        headers: {

          'Content-Type': 'application/json',

        },

        body: JSON.stringify(updatedUser),

      });


      if (!response.ok) {

        const errorData = await response.json();

        throw new Error(errorData.error || 'Failed to update profile');

      }


      const updatedData = await response.json();

      setUser(updatedData); // Update local user state with the latest data

      setIsEditing(false); // Exit edit mode

    } catch (err) {

      console.error('Failed to update user data:', err);

      setError(err.message);

    } finally {

      setLoading(false);

    }

  };


  const handleCancel = () => {

    setIsEditing(false); // Exit edit mode without saving

  };

const pg= (user)=> {
 return (
   <div className={styles.container}>

    <h1>User Profile</h1>
       <ProfileCard user={user} onEdit={() => setIsEditing(true)}/>

    {/* User ID Selection */}




    {/* Loading and Error States */}

    {loading && <p>Loading user data...</p>}

    {error && <p className={styles.error}>Error: {error}</p>}


    {/* Display User Profile */}




    {/* Edit Profile Form */}

    {isEditing && user && (
<>
      <EditProfileForm user={user} onSave={handleSave} onCancel={handleCancel}/>
    <Button onClick={() => setIsEditing(false)}>Cancel</Button>
</>
    )}

  </div>

 )
}
  const handleUserIdChange = (e) => {

    setDisplayId(Number(e.target.value))

    setUserId(Number(e.target.value) - 1);

    setIsEditing(false); // Exit edit mode if a different user is selected

  };
const spl=window.location.host.split('.')

  return  spl.length==3 && spl[0]!='new'  && spl[0]!='www'  ? (<Story sto={spl[0]=='local' ? 'ada' : spl[0]}/>) : (

    <div className="bg-white">

      <div className="flex flex-col cont" style={{justifyContent: 'space-between'}}>
          {!isEditing ? (
<div className="mx-auto">


    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"  width={coef>0.8 ? "auto" : "100vw"} height={coef>0.8 ? "70vh" : "auto"}  viewBox="0 0 818 1050">


            <path  className="nn st1" len="207.235" d="M290.36,251.78c18,0,168,2,207,8"/>
            <path  className="nn st0" len="1092.313"
                  d="M289.36,250.78c0,0-11,224-12,308s-10.97,260.52,13,280c16,13,209,18,226-1c21.84-24.41,18-207,11-270"/>
            <path  className="nn st3" len="56.086" d="M418.36,430.78c9-3,40-16,52-21"/>
            <path className="nn st2" len="232.14" d="M162.36,396.78c18,0,193-1,232,5"/>
            <g className="op">
              <path d="M256.9,1013.89c-3.15-0.19-6.24-0.57-9.3-1c-3.05-0.48-6.34-0.81-8.2-3.58c-1.62-2.43-1.53-5.82-1.72-8.63
	c-0.14-2.38-0.19-4.72-0.19-7.1c0.09-12.44,0.43-15.68,0.95-29.98c0.1-2.72,0.1-5.53,0.62-8.25c0.52-2.81,2-5.39,4.34-7.05
	c2.34-1.57,5.29-1.95,8.01-1.95h2.05c2.19,0,4.39,0.05,6.58,0.19c3.29,0.24,6.29,1.57,7.44,4.91c0.72,2.29,0.86,5.01,0.86,7.48v1.72
	c-0.05,1.53,0,3.24-0.43,4.77c-0.62,2.05-2.48,3.29-4.53,3.48c-1,0.1-2,0.14-3,0.14l-3.77-0.05c-3.53,0-7.53,0.48-10.87,0.9
	c-0.33,9.2-0.71,13.87-0.71,22.88c0,4.67,0.14,7.06,0.52,11.58l0.05,0.38c0,0,0,0.14,0.14,0.19c2.05,0.29,4.05,0.72,6.1,0.95
	c3.77,0.43,5.1,0.48,8.77,0.62c0.05-0.19,0.05-0.33,0.05-0.43l0.05-1.67c0-8.77-0.14-15.16-0.76-23.88v-0.19
	c0-1.96,1.86-3.62,3.81-3.62c2.05,0,3.57,1.72,3.72,3.72c0.53,7.01,0.81,14.02,0.81,21.07c0,1.76-0.05,3.48-0.1,5.24
	c0,1.95-0.14,3.86-1.48,5.39c-1.43,1.62-3.53,2-5.67,2C259.62,1014.12,258.19,1013.98,256.9,1013.89 M260.76,961.31
	c0-3.62,0-3.58-0.33-7.15c-0.19-0.05-0.33-0.05-0.43-0.05c-2.34-0.24-4.77-0.14-7.15-0.19h-3.05c-1.19,0.19-0.62,0-1.72,0.43
	c-0.62,0.29-0.62,0.29-0.86,0.62l0.1-0.14c0,0.05-0.43,0.67-0.43,0.67c-0.38,0.86-0.19,0.48-0.43,1.33c-0.24,1-0.19,1-0.24,1.86
	l-0.14,2.86v0.72C252.75,961.45,253.56,961.31,260.76,961.31"/>
              <path d="M293.03,1014.98c-5.53-0.57-11.01-1.24-16.45-2.1c-1.19-0.14-2.48-1.43-2.72-2.57c-0.62-3.43-1-6.86-1-10.35
	c0-1.19,0.05-2.43,0.14-3.62c0.14-2.05,1.48-3.81,3.67-3.86c1.91,0,3.86,1.62,3.86,3.53c-0.05,1.29-0.14,2.38-0.14,3.77
	c0,2.05,0.14,4.15,0.38,6.15c6.34,0.95,7.34,1,14.02,1.72l1.81,0.14c-0.48-11.3-0.33-9.11-0.76-20.59
	c-6.39,0.29-3.29,0.14-9.44,0.33c-2.1,0.09-4.24,0.19-6.34,0.24c-0.76,0.05-1.53,0.1-2.29,0.1c-1.48,0-2.96-0.24-4.1-1.33
	c-1.62-1.57-1.48-3.91-1.53-5.96c-0.38-13.97-0.29-7.34-0.48-21.12c0-2.19,0.05-4.39,0.24-6.58c0.19-1.91,0.24-4.1,1.24-5.77
	c1.24-2.05,3.43-2.57,5.67-2.62c2.81-0.1,5.58-0.14,8.39-0.14h2.77l2.62-0.05c2.62,0,5.43,0.24,7.48,1.96
	c2.34,1.95,2.53,5.05,2.53,8.01c0,9.34,0.05,4.96,0.33,14.25c0,2.34-1.86,3.58-3.72,3.58s-3.77-1.24-3.81-3.62
	c-0.19-5.48-0.24-10.96-0.53-16.45l-0.29-0.05l-0.91-0.05c-2.38-0.05-4.81-0.05-7.25-0.05c-2.29,0-4.58,0.05-6.91,0.14
	c-0.29,2.43-0.33,5.1-0.33,7.48c0,3.1,0.14,6.24,0.24,9.34l0.14,7.15c0.05,1.34,0.1,2.62,0.1,3.91l0.05,0.33
	c8.87-0.33,9.34-0.38,17.54-0.67c2.34,0,4.53,0.43,5.58,2.91c0.57,1.38,0.48,2.96,0.53,4.43c0.28,8.06,0.48,12.16,0.76,20.74
	c0.05,0.76,0.1,1.57,0.1,2.43c0,3.43-2.38,5.48-5.96,5.48C296.51,1015.55,294.61,1015.13,293.03,1014.98"/>
              <path d="M314.75,1008.21c-0.43-1.57-0.52-3.15-0.52-4.77l1.05-55.35c0.05-2.1,1.62-3.81,3.81-3.86c1.95,0,3.77,1.72,3.77,3.72
	c-0.52,23.36-0.52,26.74-1,52.15c-0.05,1.05-0.09,2.19-0.09,3.34c0,1.29,0,2.38,0.57,3.53c0.14,0.19,0.14,0.29,0.14,0.33l0.1,0.05
	c0,0.09,0.14,0.24,0.48,0.24c0.14-0.14,0.43-0.33,0.48-0.33l-0.14,0.14c0.71-0.67,0.67-0.67,1.1-1.38c2.1-3.39,3.48-7.39,5.05-11.06
	c6.82-15.64,13.01-31.75,15.16-48.81c0.19-1.76,2.1-2.81,3.81-2.81c2.38,0,3.58,2.1,3.58,4.05l-0.05,0.67
	c-1.48,11.49-5.1,23.6-9.39,34.94c1.91,8.87,3.86,17.88,7.63,26.17c0.33,0.67,0.48,1.38,0.48,2.1c0,1.86-1.38,3.62-3.72,3.62
	c-1.29,0-2.62-0.62-3.19-1.81c-2.67-5.82-4.58-11.87-6.15-17.97l-4.39,10.06c-1.67,3.81-3.57,8.01-7.77,9.58
	c-0.86,0.29-1.67,0.43-2.48,0.43C319.19,1015.17,315.75,1011.98,314.75,1008.21"/>
              <path d="M374.82,1013.89c-3.15-0.19-6.24-0.57-9.3-1c-3.05-0.48-6.34-0.81-8.2-3.58c-1.62-2.43-1.53-5.82-1.72-8.63
	c-0.14-2.38-0.19-4.72-0.19-7.1c0.1-12.44,0.43-15.68,0.95-29.98c0.1-2.72,0.1-5.53,0.62-8.25c0.52-2.81,2-5.39,4.34-7.05
	c2.34-1.57,5.29-1.95,8.01-1.95h2.05c2.19,0,4.39,0.05,6.58,0.19c3.29,0.24,6.29,1.57,7.44,4.91c0.71,2.29,0.86,5.01,0.86,7.48v1.72
	c-0.05,1.53,0,3.24-0.43,4.77c-0.62,2.05-2.48,3.29-4.53,3.48c-1,0.1-2,0.14-3,0.14l-3.77-0.05c-3.53,0-7.53,0.48-10.87,0.9
	c-0.33,9.2-0.71,13.87-0.71,22.88c0,4.67,0.14,7.06,0.52,11.58l0.05,0.38c0,0,0,0.14,0.14,0.19c2.05,0.29,4.05,0.72,6.1,0.95
	c3.77,0.43,5.1,0.48,8.77,0.62c0.05-0.19,0.05-0.33,0.05-0.43l0.05-1.67c0-8.77-0.14-15.16-0.76-23.88v-0.19
	c0-1.96,1.86-3.62,3.81-3.62c2.05,0,3.58,1.72,3.72,3.72c0.52,7.01,0.81,14.02,0.81,21.07c0,1.76-0.05,3.48-0.1,5.24
	c0,1.95-0.14,3.86-1.48,5.39c-1.43,1.62-3.53,2-5.67,2C377.53,1014.12,376.1,1013.98,374.82,1013.89 M378.68,961.31
	c0-3.62,0-3.58-0.33-7.15c-0.19-0.05-0.33-0.05-0.43-0.05c-2.34-0.24-4.77-0.14-7.15-0.19h-3.05c-1.19,0.19-0.62,0-1.72,0.43
	c-0.62,0.29-0.62,0.29-0.86,0.62l0.09-0.14c0,0.05-0.43,0.67-0.43,0.67c-0.38,0.86-0.19,0.48-0.43,1.33c-0.24,1-0.19,1-0.24,1.86
	l-0.14,2.86v0.72C370.67,961.45,371.48,961.31,378.68,961.31"/>
              <path d="M422.34,1013.6c-6.15,0-5.96-0.05-12.01-0.05c-1.91-0.05-3.86,0.05-5.53-1c-2.53-1.57-2.48-4.43-2.57-7.05
	c-0.29-9.53-0.38-13.73-0.38-23.22c0-5.72,0.05-11.44,0.19-17.11h-2.34c-2.38,0-4.29,0.05-6.53,0.09c-2.38,0-3.58-1.86-3.58-3.77
	c0-1.86,1.19-3.77,3.58-3.81c3.05-0.1,6.05-0.1,9.1-0.1c0.09-3,0.24-5.96,0.38-8.96c0.09-2.1,1.57-3.81,3.81-3.86
	c1.86,0,3.77,1.62,3.77,3.58v0.14c-0.19,3.1-0.29,6.2-0.43,9.25c2.86,0.1,5.77,0.24,8.63,0.43c2.05,0.14,3.81,1.53,3.86,3.72
	c0,1.91-1.57,3.86-3.53,3.86c-3.15-0.1-5.91-0.33-9.2-0.43c-0.14,8.01-0.14,8.01-0.19,16.45c0,7.2,0.14,13.68,0.33,20.83
	c0,1.38,0.1,2.05,0.1,3.39c6.1,0,8.49,0.1,13.68,0.1c0-0.14,0-0.33,0.05-0.48c0.24-4.77,0.33-7.82,0.33-12.68
	c0-7.01-0.29-13.97-0.81-20.98v-0.28c0-1.96,1.86-3.58,3.77-3.58c2.1,0,3.62,1.71,3.77,3.72c0.57,6.82,0.81,13.63,0.81,20.5
	c0,4.53-0.1,9.73-0.38,14.25c-0.14,1.95-0.48,3.86-1.86,5.34c-1.43,1.53-3.29,1.76-5.2,1.76L422.34,1013.6z"/>
              <path d="M444.22,1014.55c-3.34,0-6.91-0.28-8.63-3.48c-0.62-1.19-0.86-2.48-0.86-3.81c0-2.05,0.48-4.2,0.67-6.1
	c0.24-2.91,0.33-5.86,0.33-8.82c-0.05-10.3-0.91-18.78-0.91-28.22c0-1.95,0-3.86,0.1-5.82c0.14-3.15,0.14-6.63,1.67-9.53
	c1.95-3.62,5.72-4.2,9.44-4.48c3.91-0.33,7.39-0.48,11.11-0.52c2.38,0,3.62,1.91,3.62,3.81c0,1.86-1.19,3.72-3.57,3.72
	c-4.72,0.05-7.96,0.24-13.06,0.72l-0.86,0.24c0.09-0.05,0.14-0.14,0.14-0.14v-0.05c-0.33,0.43-0.14,0.19-0.38,0.76
	c-0.19,0.81-0.19,0.91-0.33,1.72c-0.29,2.43-0.38,5.15-0.38,7.91c0,9.73,0.91,18.93,1,29.13c0,5.01-0.29,9.72-0.95,14.78
	c0,0.19-0.05,0.24-0.05,0.29v0.29c5.62,0,6.24,0.1,12.2,0.14l4.91-0.05c2.43,0,3.62,1.91,3.62,3.77c0,1.86-1.19,3.77-3.58,3.77
	l-7.34,0.05L444.22,1014.55z"/>
              <path d="M502.52,1016.22c-2.05,0-3.67-1.72-3.77-3.72l-0.86-19.11c-0.14-3.19-0.29-6.34-0.48-9.53c-0.09-2.72,0.05-5.91-0.52-8.39
	c-0.05-0.29-0.19-0.62-0.33-0.91c-2.24,0.1-4.77,0.19-7.2,0.76c-0.57,0.1-1.1,0.19-1.67,0.38c-1.14,7.15-0.95,15.16-1.33,22.93
	c-0.14,2.53-0.14,5.29-0.81,7.77c-0.71,2.53-2.19,4.72-4.67,5.82c-1.14,0.48-2.53,0.72-3.91,0.72c-1.38,0-2.76-0.24-3.91-0.57
	c-5.24-1.62-5.96-6.96-5.96-11.78l0.09-5.2c0-4.58-0.24-9.06-0.48-13.63c-0.24-5.01-0.33-10.06-0.33-15.06
	c0-6.24,0.14-12.49,0.33-18.73c0.05-2.19,1.62-3.77,3.81-3.81c1.86,0,3.72,1.62,3.72,3.53c-0.14,6.44-0.33,12.73-0.33,19.16
	c0,9.39,0.71,18.69,0.81,28.13c0,1.76-0.1,3.58-0.1,5.34l0.05,1.91c0.05,1.05,0.19,2,0.53,3c0.76,0,1.33,0.1,2.15,0.1
	c0.14,0,0.38,0,0.52,0.05c0-0.14,0.19-0.19,0.19-0.24l-0.19,0.19c0.53-1.05,0.62-1.77,0.72-3.29c0.48-6.39,0.48-13.63,0.95-20.55
	c0.19-2.67,0.19-5.67,1-8.25c0.95-3.05,3.43-4.48,6.44-5.1c3.77-0.86,6.15-1.05,9.96-1.14c1.05,0,2.1,0.1,3.05,0.52
	c3.76,1.62,4.53,6.58,4.77,10.92l1.57,34.13c0,2-1.76,3.62-3.72,3.67H502.52z"/>
              <path d="M520.73,1012.84c-2.77-0.19-6.29,0.1-8.44-2.05c-2.19-2.14-1.91-5.67-2.05-8.48c-0.14-2.86-0.19-5.77-0.19-8.63
	c0-5.77,0.29-11.54,0.76-17.26c0.19-2.05,1.52-3.81,3.72-3.86c1.81,0,3.86,1.57,3.86,3.48v0.24c-0.52,5.58-0.76,11.15-0.81,16.68
	c0,3.72,0.1,7.96,0.38,12.01v0.09c4.53,0.43,9.06,0.67,13.59,0.81h0.24c0.05-0.48,0.09-1,0.09-1.43c0-2.38-0.24-4.72-0.48-7.05
	c-0.33-3.29-0.48-6.53-0.48-9.77c0-11.68,1.76-22.55,1.86-33.22l-0.05-2.29c-2.29,0.05-4.58,0.05-6.91,0.05l-7.44,0.05
	c-0.19,0-0.38,0-0.62,0.05c-0.43,3.77-0.52,7.87-0.52,11.35l0.05,4.15c0,2.1-1.76,3.67-3.77,3.67c-2.05,0-3.72-1.72-3.77-3.72
	l-0.1-4.05c0-3.58,0.19-6.77,0.43-10.25c0.14-1.53,0.19-3.15,0.62-4.58c1.19-3.77,4.77-4.15,8.1-4.2l15.02-0.05
	c1.19,0,2.38,0.05,3.48,0.57c2.96,1.48,3,4.58,3,7.44v1.1c0,10.34-1.86,22.69-1.91,33.61c0,5.43,0.91,10.77,1,16.21l0.05,1.76
	c0,2.34-0.29,4.81-1.95,6.48c-1.53,1.43-3.48,1.72-5.43,1.72C528.22,1013.46,524.17,1013.12,520.73,1012.84"/>
              <path d="M565.02,1014.98c-5.53-0.57-11.01-1.24-16.45-2.1c-1.19-0.14-2.48-1.43-2.72-2.57c-0.62-3.43-1-6.86-1-10.35
	c0-1.19,0.05-2.43,0.14-3.62c0.14-2.05,1.48-3.81,3.67-3.86c1.91,0,3.86,1.62,3.86,3.53c-0.05,1.29-0.14,2.38-0.14,3.77
	c0,2.05,0.14,4.15,0.38,6.15c6.34,0.95,7.34,1,14.02,1.72l1.81,0.14c-0.48-11.3-0.33-9.11-0.76-20.59
	c-6.39,0.29-3.29,0.14-9.44,0.33c-2.1,0.09-4.24,0.19-6.34,0.24c-0.76,0.05-1.53,0.1-2.29,0.1c-1.48,0-2.96-0.24-4.1-1.33
	c-1.62-1.57-1.48-3.91-1.53-5.96c-0.38-13.97-0.29-7.34-0.48-21.12c0-2.19,0.05-4.39,0.24-6.58c0.19-1.91,0.24-4.1,1.24-5.77
	c1.24-2.05,3.43-2.57,5.67-2.62c2.81-0.1,5.58-0.14,8.39-0.14h2.76l2.62-0.05c2.62,0,5.44,0.24,7.48,1.96
	c2.34,1.95,2.53,5.05,2.53,8.01c0,9.34,0.05,4.96,0.33,14.25c0,2.34-1.86,3.58-3.72,3.58c-1.86,0-3.77-1.24-3.81-3.62
	c-0.19-5.48-0.24-10.96-0.53-16.45l-0.29-0.05l-0.91-0.05c-2.38-0.05-4.82-0.05-7.25-0.05c-2.29,0-4.58,0.05-6.91,0.14
	c-0.29,2.43-0.33,5.1-0.33,7.48c0,3.1,0.14,6.24,0.24,9.34l0.14,7.15c0.05,1.34,0.09,2.62,0.09,3.91l0.05,0.33
	c8.87-0.33,9.34-0.38,17.54-0.67c2.34,0,4.53,0.43,5.58,2.91c0.57,1.38,0.48,2.96,0.53,4.43c0.29,8.06,0.48,12.16,0.76,20.74
	c0.05,0.76,0.1,1.57,0.1,2.43c0,3.43-2.38,5.48-5.96,5.48C568.5,1015.55,566.59,1015.13,565.02,1014.98"/>
            </g>
          </svg>

          <div className="flex justify-center  content-center">
            <Link to="/gallery">  <AppsTwoTone/></Link>
         <Link to="/draw">  <DrawTwoToneIcon/></Link>
            <a href='#' onClick={(e)=>userb()}>   <AccountBoxTwoTone style={{opacity: user ? 1 : .3}}/></a>

            <HelpTwoTone/>
            <ShareTwoTone/>
          </div>
</div>

          ) : pg(user)}
        <div className="flex flex-col p-2 justify-items-center justify-center content-center ">
          <div className="mx-auto content-center"><span>eSketchos.art</span>
        <br/>  © Aleksandr Potolitsyn 2025</div>
        </div>
      </div>


    </div>


)


};


export default ProfilePage;







